import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';

import styles from './XCircle.module.css';
import d from './d';

export interface XCircleIconSvgProps {
  s?: CSSProperties;
}

const XCircleIcon: FC<XCircleIconSvgProps> = ({ s }) => {
  const { iconsPrimaryNone: iconStyle } = useTheme();
  const style = {
    ...iconStyle,
    ...s,
  };

  return (
    <svg
      role="presentation"
      className={styles.container}
      style={{ fill: style?.color, ...style }}
      viewBox="0 0 48 48"
    >
      <path d={d} />
    </svg>
  );
};

export default XCircleIcon;
